import { ValueFormatterParams } from 'ag-grid-community';
import { parseDateString } from '../../../utils/helper';
import { TimeUtilities } from '../TimeUtilities';

export function dateFormat(params: ValueFormatterParams): string {
  if (!params.value) {
    return '';
  }
  return parseDateString(params.value) ?? '';
}

export function preorderDateFormat(params: ValueFormatterParams): string {
  if (!params.value) {
    return '';
  }
  const date = parseDateString(params.value);
  if (date && params.data.preOrderTime) {
    return `${parseDateString(params.value)} ${params.data.preOrderTime} UTC`;
  }
  return date ?? '';
}

export const submissionsGridUrl: string = '/Physical/Submissions';
export const merchandiseSubmissionsGridUrl: string = '/Merchandise/Submissions';
export const merchandiseReleasesGridUrl: string = '/Merchandise/Releases';
export const releasesGridUrl: string = '/Physical/Releases';

export function durationFormat(params: ValueFormatterParams): string {
  if (!params.value) {
    return '';
  }
  return TimeUtilities.convertSecondsToTimeString(params.value) ?? '';
}
